export class ConnectorDeltaUpdate {
  ID: number;
  StationId: string;
  Name: string;
  Description: string;
  EnergyPrice: number;
  ParkingPrice: number;
  AccessType: number;
  PlugType: number;
  MaxPower: number;
  IsAutoChargeEnabled: boolean;
  IsHubjectEnabled: boolean;
  HubjectPricingProductId: string;
}
